import { useEffect, useState } from "react";
import { Logo } from "./Logo";

const LangToggle = ({ lang, setLang }) => (
  <div className="flex rounded-full border border-white/15 p-1 font-mono text-[11px]" data-testid="language-toggle">
    {["es", "en"].map((l) => (
      <button
        key={l}
        onClick={() => setLang(l)}
        data-testid={`language-toggle-${l}`}
        aria-pressed={lang === l}
        className={`rounded-full px-3 py-1 uppercase tracking-widest transition-colors duration-300 ${
          lang === l ? "bg-[var(--gold)] text-[var(--ink)]" : "text-[var(--ivory)] hover:text-[var(--gold)]"
        }`}
      >
        {l}
      </button>
    ))}
  </div>
);

export const Header = ({ t, lang, setLang, go }) => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,padding,border-color] duration-500 ${
        scrolled ? "border-b border-white/10 bg-[#0e1420]/80 py-3 backdrop-blur-xl" : "border-b border-transparent py-5"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 lg:px-10">
        <Logo onClick={() => go("top")} />
        <nav className="hidden items-center gap-9 md:flex">
          {["about", "services", "contact"].map((id) => (
            <button key={id} onClick={() => go(id)} data-testid={`nav-link-${id}`} className="nav-link text-sm text-[#f4f1ea]/80 hover:text-[var(--ivory)]">
              {t.nav[id]}
            </button>
          ))}
        </nav>
        <LangToggle lang={lang} setLang={setLang} />
      </div>
    </header>
  );
};
